import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('tip'), _c('div', {
    staticClass: "status-tabs"
  }, [_c('span', [_vm._v(_vm._s(_vm.t('状态')) + _vm._s(_vm.t('common', '：')))]), _c('a-tabs', {
    attrs: {
      "data-permission": "notice_list_smMessagePage_is_acked",
      "id": "notice_list_smMessagePage_is_acked",
      "animated": false
    },
    on: {
      "change": _vm.handleReadStatusChange
    },
    model: {
      value: _vm.searchData.is_acked,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "is_acked", $$v);
      },
      expression: "searchData.is_acked"
    }
  }, [_vm._l(_vm.readStatusList, function (item) {
    return [_c('a-tab-pane', {
      key: item.value,
      attrs: {
        "tab": item.label
      }
    })];
  })], 2)], 1), _c('div', {
    staticClass: "status-tabs mb-20"
  }, [_c('span', [_vm._v(_vm._s(_vm.t('分类')) + _vm._s(_vm.t('common', '：')))]), _c('a-tabs', {
    attrs: {
      "data-permission": "notice_list_smMessagePage_type_id",
      "id": "notice_list_smMessagePage_type_id",
      "animated": false
    },
    on: {
      "change": _vm.handleTabChange
    },
    model: {
      value: _vm.searchData.type_id,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "type_id", $$v);
      },
      expression: "searchData.type_id"
    }
  }, [_c('a-tab-pane', {
    key: undefined,
    attrs: {
      "fbu-analyse-name": $t("\u5168\u90E8"),
      "tab": _vm.t('全部')
    }
  }), _vm._l(_vm.categoryList, function (item) {
    return [_c('a-tab-pane', {
      key: item.id,
      attrs: {
        "tab": item.title_cn
      }
    })];
  })], 2)], 1), _c('div', {
    staticClass: "announce-wrap"
  }, [_c('div', {
    staticClass: "left-panel"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "filter-box"
  }, [_c('my-input', {
    staticClass: "search-input-item",
    attrs: {
      "fbu-analyse-name": $t("\u8BF7\u8F93\u5165\u5173\u952E\u5B57"),
      "data-permission": "notice_list_smMessagePage_keyword",
      "id": "notice_list_smMessagePage_keyword",
      "show-tip": "",
      "placeholder": _vm.t('请输入关键字')
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        return _vm.handleSearch($event);
      }
    },
    model: {
      value: _vm.searchData.keyword,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "keyword", $$v);
      },
      expression: "searchData.keyword"
    }
  }), _c('a-button', {
    staticClass: "search-btn-item",
    attrs: {
      "data-permission": "searchNoticeListId",
      "id": "searchNoticeListId",
      "type": "primary",
      "data-sign": "message_query",
      "fbu-analyse-name": $t("\u641C\u7D22")
    },
    on: {
      "click": _vm.handleSearch
    }
  }, [_vm._v(_vm._s(_vm.t('搜索')))])], 1), _c('div', {
    staticClass: "notice-box",
    attrs: {
      "id": "noticeListBoxId"
    }
  }, [_vm.dataList.length ? _c('div', {
    staticClass: "infinite-container"
  }, [_vm._l(_vm.dataList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "infinite-list-item"
    }, [_c('div', {
      staticClass: "infinite-item",
      class: {
        'active': item.id === _vm.curAnnounceId
      },
      on: {
        "click": function ($event) {
          return _vm.handleClickAnnounce(item);
        }
      }
    }, [_c('span', {
      staticClass: "title-item",
      class: [item.is_highlight ? 'lighting-color' : ''],
      domProps: {
        "innerHTML": _vm._s(_vm.$util.filterXSS(item.title))
      }
    }), _c('div', {
      staticClass: "status-time"
    }, [item.acked === 0 ? _c('span', {
      staticClass: "read-status lighting"
    }, [_vm._v(_vm._s(_vm.t('未读')))]) : _c('span', {
      staticClass: "read-status"
    }, [_vm._v(_vm._s(_vm.t('已读')))]), item.released_on ? _c('span', {
      staticClass: "release-time"
    }, [_vm._v(_vm._s(_vm.t('发布:')) + " " + _vm._s(item.released_on))]) : _vm._e()])])]);
  }), _vm.listDataPending ? _c('div', {
    staticClass: "icon-loading"
  }, [_c('a-spin')], 1) : _vm._e()], 2) : _vm._e(), !_vm.listDataPending && !_vm.dataList.length ? _c('div', [!_vm.listDataPending && !_vm.dataList.length ? _c('a-empty', {
    staticClass: "mt-100",
    attrs: {
      "description": _vm.t('暂无数据')
    }
  }) : _vm._e()], 1) : _vm._e(), _vm.isShowLoadMore && !_vm.listDataPending && _vm.dataList.length > 0 ? _c('div', {
    staticClass: "load-more"
  }, [_c('a-button', {
    staticClass: "load-more-btn",
    attrs: {
      "type": "primary",
      "data-permission": "notice_list_smMessagePage_load_more_btn",
      "id": "notice_list_smMessagePage_load_more_btn",
      "block": "",
      "fbu-analyse-name": $t("\u52A0\u8F7D\u66F4\u591A")
    },
    on: {
      "click": _vm.handleLoadMore
    }
  }, [_vm._v(_vm._s(_vm.t('加载更多')))])], 1) : _vm._e(), !_vm.isShowLoadMore && !_vm.listDataPending && _vm.dataList.length > 0 ? _c('div', {
    staticClass: "all-data line-center"
  }, [_vm._v(_vm._s(_vm.t('全部数据')) + " ")]) : _vm._e()])])])]), _c('div', {
    staticClass: "right-panel",
    attrs: {
      "id": "rightPanelId"
    }
  }, [_c('div', {
    staticClass: "notice-wrap",
    attrs: {
      "id": "noticeDetailBoxId"
    }
  }, [_c('div', {
    staticClass: "notice-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$util.filterXSS(_vm.detailData.title))
    }
  }), _vm.detailData.released_on ? _c('div', {
    staticClass: "notice-time"
  }, [_vm._v(_vm._s(_vm.t('时间：'))), _c('span', [_vm._v(_vm._s(_vm.detailData.released_on))])]) : _vm._e(), _c('div', {
    staticClass: "notice-content",
    attrs: {
      "id": "noticeContentId"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$util.filterXSS(_vm.detailData.content))
    }
  }), _vm.detailData.attachment_list && _vm.detailData.attachment_list.length ? _c('div', {
    staticClass: "notice-attachment",
    attrs: {
      "id": "noticeAttachmentId"
    }
  }, [_c('div', {
    staticClass: "notice-attachment-label"
  }, [_vm._v(_vm._s(_vm.t('附件：')))]), _c('div', _vm._l(_vm.detailData.attachment_list, function (attItem, index) {
    return _c('div', {
      key: index
    }, [_c('a', {
      staticClass: "attachment-item",
      attrs: {
        "href": attItem.remote_url + '&download=1',
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "download-icon"
    }), _c('span', {
      staticStyle: {
        "color": "#548df8"
      }
    }, [_vm._v(_vm._s(attItem.file_name))])])]);
  }), 0)]) : _vm._e()]), !_vm.listDataPending && !_vm.dataList.length ? _c('a-empty', {
    staticClass: "mt-100",
    attrs: {
      "description": _vm.t('暂无数据')
    }
  }) : _vm._e()], 1)])], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };